export default __webpack_public_path__ + "static/media/modal-bg.5e22d3b0.png";